import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';
import { VoucherFormBlackoutPeriod } from '../../components/VoucherForm/Rules/BlackoutPeriod';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormTravelPeriod } from '../../components/VoucherForm/Rules/TravelPeriod';
import { VoucherFormTrips } from '../../components/VoucherForm/Rules/Trips';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddHybridPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Hybrid',
    voucherType: 'Hybrid',
    reasonField: false,
    specificationLabel: 'Specification (campaign/partner name)',
    specificationRequired: true,
  };

  const VoucherFormDiscountTemplate = {
    disabled: true,
    discountType: 'free_ride_hybrid',
    showFreeAncillaries: true,
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: false,
    disableValidity: false,
  };

  return (
    <>
      <VoucherFormBanner title='Hybrid (for partners)' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity />
            <VoucherFormStructure />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormRulesTitle />
            <VoucherFormTrips />
            <VoucherFormCountriesAndLines />
            <VoucherFormTravelPeriod />
            <VoucherFormBlackoutPeriod />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddHybridPage;
